import { Component, ElementRef, EventEmitter, Output, ViewChild, afterRenderEffect, computed, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { regularWithdrawalFrequencyMap } from 'src/models/common.model';
import { ERegularWithdrawalDraftStatus, investmentGoalTranslateMap, IRegularWithdrawalDraft } from 'src/models/products.model';
import dayjs from 'dayjs';
import { IPortfolioAvatarInput } from '../liberro-avatar-photo-tagged/liberro-avatar-photo-tagged.component';

@Component({
  selector: 'liberro-regular-withdrawal-draft-card',
  standalone: false,
  templateUrl: './regular-withdrawal-draft-card.component.html',
  styleUrl: './regular-withdrawal-draft-card.component.less'
})
export class RegularWithdrawalDraftCardComponent {
  private sanitizer = inject(DomSanitizer);
  public draftWithdrawal = input.required<IRegularWithdrawalDraft>();
  @Output() public accept = new EventEmitter<void>();
  @Output() public refuse = new EventEmitter<number>();
  @Output() public updateAml = new EventEmitter<void>();
  @Output() public readFullComment = new EventEmitter<SafeHtml>();
  public regularWithdrawalFrequencyMap = regularWithdrawalFrequencyMap;

  public waitingForMailConfirm = computed<boolean>(() =>
    this.draftWithdrawal().status === ERegularWithdrawalDraftStatus.PENDING_DIP_APPROVAL
  );

  public isExpired = computed<boolean>(() =>
    dayjs(this.draftWithdrawal().validTo).isBefore(dayjs())
  );

  public draftImageInfo = computed<IPortfolioAvatarInput>(() => {
    return {
      portfolioType: this.draftWithdrawal().portfolioManagementType,
      image: this.draftWithdrawal().image,
    }
  });

  public goalInfo = computed<{label: string; icon: string; }>(() => this.getGoalInfo());
  private getGoalInfo(): { label: string; icon: string; } {
    const draft = this.draftWithdrawal();
    const goal = draft?.investmentGoalType;
    return goal ? investmentGoalTranslateMap[goal] : { label: '', icon: '' };
  }

  @ViewChild('commentText') public commentTextRef!: ElementRef<HTMLParagraphElement>;
  public isCommentClamped = signal<boolean>(false);

  public constructor() {
    afterRenderEffect(() => {
      const el = this.commentTextRef?.nativeElement;
      if (el) this.isCommentClamped.set(this.isTextClamped(el));
    });
  }

  private isTextClamped(el: HTMLElement): boolean {
    const clampedHeight = el.clientHeight;
    el.style.overflow = 'visible';
    const fullHeight = el.scrollHeight;
    el.style.removeProperty('overflow');
    return fullHeight > clampedHeight;
  }

  public collaboratorFullName = computed<string>(() => {
    const { firstName, lastName } = this.draftWithdrawal().collaborator.name;
    return `${firstName} ${lastName}`.trim();
  });

  public collaboratorCommentary = computed<SafeHtml>(() => {
      return this.sanitizer.bypassSecurityTrustHtml(this.draftWithdrawal().message);
  });
}
